import { BaseFormatEvent } from 'common/event-handling/base-format-event.model';
import { Constructor } from 'common/event-handling/contructor.type';
import { PreloadErrorEvent } from 'common/event-handling/events';
import { OcsPreloadedEvent } from '../../event-handling/ocs-preloaded-event';
import { MRAIDFormatStateStore } from './mraid-format-state-store';

export class OcsMRAIDFormatStateStore extends MRAIDFormatStateStore {
  protected subscribeToBus(
    preloadClasses: {
      preload: Constructor<BaseFormatEvent>;
      preloadError: Constructor<BaseFormatEvent>;
    } = {
      preload: OcsPreloadedEvent,
      preloadError: PreloadErrorEvent
    }
  ) {
    super.subscribeToBus(preloadClasses);
  }
}
